export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5299.3bffc487.jpg";